module.exports = __webpack_public_path__ + "img/purple-1-diamond-open.97e41618.svg";